import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const WellnessPromotionBackgroundTop = forwardRef<SVGSVGElement, SvgIconProps>(
  function WellnessPromotionBackgroundTop(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M -0.053 24.013 L -0.053 10.667 C 5.133 14.186 8.159 13.518 12.899 12.265 C 17.434 11.067 21.718 11.931 24 13.967 L 24 24.013 L -0.053 24.013 Z" />
      </SvgIcon>
    )
  },
)

export default WellnessPromotionBackgroundTop
